module.exports = __webpack_public_path__ + "static/media/lafise-provider.b71b4d86.svg";